import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { fromConsultant } from '../reducers/consultant.reducer';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  exceptions = ['.s3.'];

  constructor(private store: Store) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.store.pipe(select(fromConsultant.selectConsultantState)).subscribe(consultant => {

      if (consultant?.token && !this.exceptions.some(url => request.url.includes(url))) {
        request = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + consultant.token,
            'X-Frame-Options': 'SAMEORIGIN'
          }
        });
      }

    });

    return next.handle(request);
  }
}
